import React, { Component } from "react";
import { Grid, Col, Row } from "react-bootstrap";
import Card from "../../components/Card/Card.jsx";
import StatsCard from "../../components/Card/StatsCard.jsx";
import SweetAlert from "react-bootstrap-sweetalert";
import {Pie, Bar} from 'react-chartjs-2';
import DashboardService from "../../services/DashboardService";
import { defaults } from 'react-chartjs-2';

// Disable animating charts by default.
defaults.global.legend.position = "left";

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alert: null,
      enterprisingCount: 0,
      incubationProjectsCount: 0,
      announcementesCount: 0,
      UNCLinkedChart: {},
      projectsByStatus: {},
      hoursByATG: {},
      projectsByYearStatus: {},
      emprendedoresPorConvocatoria: {},
    };
    this.dashboardService = new DashboardService();
    this.errorAlert = this.errorAlert.bind(this);
  }

  componentWillMount() {
    this.getEnterprisingCount();
    this.getAnnouncementsCount();
    this.getAnnouncementsUNCLinkedCount();
    this.getIncubationProjectsCount();
    this.getProjectsByStatus();
    this.getHoursByATG();
    this.getProjectsByYearStatus();
    this.getEmprendedoresXConvocatoria();
  }

  getEmprendedoresXConvocatoria() {
    this.dashboardService.getEmprendedoresXConvocatoria()
    .then(res => {
      let data = {
        labels: res.data.labels,
        datasets: [{
            type: 'bar',
            label: 'Emprendedores',
            data: res.data.series[0],
            fill: false,
            backgroundColor: '#FF6384',
            borderColor: '#FF6384',
            hoverBackgroundColor: '#FF6384',
            hoverBorderColor: '#FF6384',
          },{
            type: 'bar',
            label: 'Postulados',
            data: res.data.series[1],
            fill: false,
            backgroundColor: '#59CAED',
            borderColor: '#59CAED',
            hoverBackgroundColor: '#59CAED',
            hoverBorderColor: '#59CAED',
          }]
      };

      this.setState({ emprendedoresPorConvocatoria: data });
    })
    .catch(err => {
      console.log(err);
      this.setState({errorEmprendedoresPorConvocatoria: true});
    });
  }

  getIncubationProjectsCount() {
    this.dashboardService.getIncubationProjectsCount()
    .then(res => {
      this.setState({ incubationProjectsCount: res.total });
    })
    .catch(err => {
      console.log(err);
      this.setState({errorIncubationProjectsCount: true});
    });
  }

  getAnnouncementsCount() {
    this.dashboardService.getAnnouncementsCount()
    .then(res => {
      this.setState({ announcementesCount: res.total });
    })
    .catch(err => {
      console.log(err);
      this.setState({errorAnnouncementsCount: true});
    });
  }

  getAnnouncementsUNCLinkedCount() {
    this.dashboardService.getAnnouncementsUNCLinkedCount()
    .then(res => {
      let dataPie = {
          labels: [],
          datasets: [{
            data: [],
            backgroundColor: [
            '#FF6384',
            '#59CAED'
            ],
            hoverBackgroundColor: [
            '#FF6384',
            '#59CAED'
            ]
          }]
      };
      res.data.forEach((item) => {
        dataPie.labels.push(item.name);
        dataPie.datasets[0].data.push(parseInt(item.value, 10));
      });

      this.setState({ UNCLinkedChart: dataPie });
    })
    .catch(err => {
      console.log(err);
      this.setState({errorUNCLinkedCharts: true});
    });
  }

  getProjectsByStatus() {
    this.dashboardService.getProjectsByStatus()
    .then(res => {
      let dataPie = {
          labels: [],
          datasets: [{
            data: [],
            backgroundColor: [
            '#FF6384',
            '#59CAED',
            '#F7CF5A',
            '#955EE8'
            ],
            hoverBackgroundColor: [
            '#FF6384',
            '#59CAED',
            '#F7CF5A',
            '#955EE8'
            ]
          }]
      };
      //console.log(res)
      res.data.forEach((item) => {
        dataPie.labels.push(item.nombre);
        dataPie.datasets[0].data.push(parseInt(item.total, 10));
      });
      this.setState({ projectsByStatus: dataPie });
    })
    .catch(err => {
      console.log(err);
      this.setState({errorProjectsByStatus: true});
    });
  }

  getHoursByATG() {
    this.dashboardService.getHoursByATG()
    .then(res => {
      let dataChart = {
        labels: res.data.labels,
        datasets: [{
            type: 'bar',
            label: 'Horas de Asistencia Técnica',
            data: res.data.series[0],
            fill: false,
            backgroundColor: '#F7CF5A',
          },{
            type: 'bar',
            label: 'Horas de Tutoría',
            data: res.data.series[1],
            fill: false,
            backgroundColor: '#955EE8',
          }]
      };
      this.setState({ hoursByATG: dataChart });
    })
    .catch(err => {
      console.log(err);
      this.setState({errorProjectsByStatus: true});
    });
  }
  getRandomColor() {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }
  getProjectsByYearStatus() {
    this.dashboardService.getProjectsByYearStatus()
    .then(res => {
      // res.data.series / res.data.labels
      let data = {
        labels: res.data.labels,
        datasets: [{
            type: 'bar',
            label: 'Seleccionados',
            data: res.data.series[0],
            fill: false,
            backgroundColor: '#FF6384',
            borderColor: '#FF6384',
            hoverBackgroundColor: '#FF6384',
            hoverBorderColor: '#FF6384',
          },{
            type: 'bar',
            label: 'Ideas Proyecto',
            data: res.data.series[1],
            fill: false,
            backgroundColor: '#59CAED',
            borderColor: '#59CAED',
            hoverBackgroundColor: '#59CAED',
            hoverBorderColor: '#59CAED',
          }]
      };
      this.setState({ projectsByYearStatus: data})
    })
    .catch(err => {
      console.log(err);
      this.setState({errorProjectsByYearStatus: true});
    });
  }

  getEnterprisingCount() {
    this.dashboardService
    .getEnterprisingCount()
    .then(res => {
      this.setState({ enterprisingCount: res.total });
    })
    .catch(err => {
      console.log(err);
      this.setState({errorEnterprisingCount: true});
    });
  }
  hideAlert() {
    this.setState({
        alert: null
    });
  }
  errorAlert(message) {
    this.setState({
      alert: (
        <SweetAlert
          error
          style={{ display: "block", marginTop: "-100px" }}
          title="Error"
          onConfirm={() => this.hideAlert()}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="danger"
          confirmBtnText="Aceptar"
        >
          {message}
        </SweetAlert>
      )
    });
  }
  render() {
    const asistencias = `http://${window.location.hostname}/api/reports/asistencias`;
    const emprendedores = `http://${window.location.hostname}/api/reports/emprendedores`;
    const contactos = `http://${window.location.hostname}/api/reports/contactos`;
    return (
      <div className="main-content">
        <Grid fluid>
          <Row>
            <Col lg={4} sm={12}>
              <StatsCard
                bigIcon={<i className="pe-7s-light text-warning" />}
                statsText="Emprendedores"
                statsValue={this.state.enterprisingCount}
                statsIcon={<i className="fa fa-info-circle text-info" />}
                statsIconText="Info"
                statsDescription="Suma de emprendedores que forman parte de un proyecto activo en etapa PRE-INCUBACION e INCUBACION"
              />
            </Col>
            <Col lg={4} sm={12}>
              <StatsCard
                bigIcon={<i className="pe-7s-display1 text-success" />}
                statsText="Proyectos Activos"
                statsValue={this.state.incubationProjectsCount}
                statsIcon={<i className="fa fa-info-circle text-info" />}
                statsIconText="Info"
                statsDescription="Suma de proyectos activos en etapa PRE-INCUBACION e INCUBACION"
              />
            </Col>
            <Col lg={4} sm={12}>
              <StatsCard
                bigIcon={<i className="fa fa-calendar-o text-info" />}
                statsText="Convocatorias"
                statsValue={this.state.announcementesCount}
                statsIcon={<i className="fa fa-info-circle text-info" />}
                statsIconText="Info"
                statsDescription="Convocatorias totales cargadas en el sistema"
              />
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Card
                title="Proyectos con emprendedores vinculados a la UNCuyo"
                category=""
                content={<Pie data={this.state.UNCLinkedChart} />}
                legend=""
              />
            </Col>
            <Col md={6}>
              <Card
                title="Total de proyectos activos y graduados"
                category=""
                content={<Pie data={this.state.projectsByStatus} />}
                legend=""
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Card
                title="Proyectos postulados y seleccionados por convocatoria"
                category=""
                content={
                  <Bar
                    data={this.state.projectsByYearStatus}
                    options={{
                      maintainAspectRatio: true
                    }}
                  />
                }
                legend=""
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Card
                title="Cantidad de emprendedores por convocatoria"
                category=""
                content={
                  <Bar
                    data={this.state.emprendedoresPorConvocatoria}
                    options={{
                      maintainAspectRatio: true,
                      scales: {
                        yAxes: [{ ticks: {beginAtZero: true} }]
                      }
                    }}
                  />
                }
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Card
                title="Horas de asistencia técnica a emprendimientos"
                category=""
                content={
                  <Bar
                    data={this.state.hoursByATG}
                    options={{
                      maintainAspectRatio: true,
                      scales: {
                        yAxes: [{ ticks: {beginAtZero: true} }]
                      }
                    }}
                  />
                }
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Card
                title="Links para importación en Excel"
                category=""
                content={
                  <p>
                    <p>Reporte asistencias técnicas -> <a href={asistencias}>{asistencias}</a></p>
                    <p>Reporte emprendedores -> <a href={emprendedores}>{emprendedores}</a></p>
                    <p>Reporte contactos -> <a href={contactos}>{contactos}</a></p>
                  </p>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/views/Dashboard/Dashboard.jsx